module.exports = __webpack_public_path__ + "img/12.78d45413.jpg";